import { render } from "./AddEditUser.vue?vue&type=template&id=394689c1&ts=true"
import script from "./AddEditUser.ts?vue&type=script&lang=ts&external"
export * from "./AddEditUser.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__